import React from "react";
import {
  Box,
  Flex,
  Text,
  Button,
  Tag,
} from "@chakra-ui/react";
import { FaExternalLinkAlt } from "react-icons/fa";
import { ModalBox } from "../../components/ModalBox";
import { PricingPlan } from "../PricingPlan";
import { useBilling } from "./useBilling"
import { LoadingOverlay } from "../../components/LoadingOverlay";

export const Billing = () => {

  const {
    isOpen,
    onOpen,
    onClose,
    downgradeToFree,
    publisher,
    cancelPlanIsOpen,
    cancelPlanOnOpen,
    cancelPlanOnClose,
    loading,
    getCustomerPortalUrl
  } = useBilling();

  return (
    <>
      {loading && <LoadingOverlay />}
      <Box bg="gray.50">
        {/* Your Plan */}
        <Box bg="white" p={6} borderRadius="lg" mb={4} boxShadow="sm">
          <Flex align="center" mb={2}>
            <Text fontSize="lg" fontWeight="bold">
              Your Plan
            </Text>
          </Flex>
          <Flex align="center" mb={2} justifyContent="space-between">
            <Box>
              <Tag colorScheme="purple" mr={4}>
                {publisher?.accountType}
              </Tag>
              {
                publisher?.isPro ?
                  <>
                    <Text fontSize="2xl" fontWeight="bold">
                      ${publisher?.subscriptionInfo?.price}
                      <Text as="span" fontSize="md" fontWeight="normal" color="gray.500">
                        {publisher?.subscriptionInfo?.frequency === "month" ? `/month` : `/year (Billed yearly)`}
                      </Text>
                    </Text>
                    <Text color="gray.600" mb={4}>
                      For professionals with big access
                    </Text>
                  </> :
                  <>
                    <Text fontSize="2xl" fontWeight="bold">
                      $0
                    </Text>
                    <Text color="gray.600" mb={4}>
                      Free Plan
                    </Text>
                  </>
              }
            </Box>
            <Flex>
              {
                publisher?.isPro ?
                  <Button variant="ghost" color="red.500" mr={2} onClick={cancelPlanOnOpen}>
                    Cancel Plan
                  </Button> : null
              }
              <Button colorScheme="blue" onClick={onOpen}>Change Plan</Button>
            </Flex>
          </Flex>
        </Box>

        {/* Invoices & Billing */}
        {
          publisher?.isPro ?
            <Box bg="white" p={6} borderRadius="lg" boxShadow="sm">
              <Flex align="center" justifyContent="space-between">
                <Box>
                  <Text fontSize="lg" fontWeight="bold" mb={2}>
                    Invoices & Billing
                  </Text>
                  <Text color="gray.600" mb={4}>
                    Manage your invoice history and billing details for your subscriptions
                  </Text>
                </Box>
                <Button variant="outline" rightIcon={<FaExternalLinkAlt />} colorScheme="blue" onClick={getCustomerPortalUrl}>
                  Manage Billing
                </Button>
              </Flex>
            </Box> : null
        }
        <ModalBox
          title="Change Plan"
          isOpen={isOpen}
          onClose={onClose}
          isFooter={false}
          onCancel={onClose}
          confirmButtonType={false}
          size={"full"}
          description={
            <PricingPlan isPro={publisher.isPro} />
          }
        />
        <ModalBox
          title="Cancel Plan"
          isOpen={cancelPlanIsOpen}
          onClose={cancelPlanOnClose}
          isFooter={true}
          onCancel={cancelPlanOnClose}
          confirmButtonType={true}
          onConfirm={downgradeToFree}
          isDeleteButton={true}
          confirmButtonText="Downgrade To Free"
          description={`Are you sure you want to downgrade to free plan?`}
        />
      </Box>
    </>
  );
};
